import { useImmerAtom } from 'jotai-immer';
import { useTableData } from '../../../../core/table/hooks/useTableData';
import {
    cpOrderInvoicesDataAtom,
    cpOrderInvoicesTableFiltersAtom,
    cpOrderInvoicesTableStatsAtom,
    cpOrderInvoicesTableViewAtom,
} from '../cp_order_invoices_list_atoms';
import { CpOrderInvoicesDataHook } from '../cp_order_invoices_list_types';

/**
 * Hook to get CP Order Invoices table data and raw data size.
 * Mirrors useFeedsData pattern.
 */
export function useCpOrderInvoicesData(): CpOrderInvoicesDataHook {
    const [view] = useImmerAtom(cpOrderInvoicesTableViewAtom);
    const [filters] = useImmerAtom(cpOrderInvoicesTableFiltersAtom);
    const [stats, setStats] = useImmerAtom(cpOrderInvoicesTableStatsAtom);
    const [data] = useImmerAtom(cpOrderInvoicesDataAtom);

    const { items } = useTableData({
        view,
        filters,
        stats,
        data,
        setStats,
    });

    return { items, rawDataSize: data.dataItems.length };
}
